import { AccountNavigationList } from '@playbooks/components/account/account-navigation-list';
import { GuestAboutCard } from '@playbooks/components/guest/guest-about-card';

const GuestDropAbout = ({ target, onView }) => (
	<>
		<div className='border-b border-border p-1'>
			<GuestAboutCard />
		</div>
		<AccountNavigationList target={target} onView={onView} />
	</>
);

export { GuestDropAbout };
